
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5352',
  depVersions: {
  "data-privacy-request-ui": "static-1.5352",
  "data-fetching-client": "static-1.9505",
  "head-dlb": "static-1.4841",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7835",
  "hub-http-shared-msw-handlers": "static-1.9534",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11264",
  "I18n": "static-7.1580",
  "jasmine-runner": "static-1.6299",
  "privacy-center-public-service-types": "static-1.4615",
  "quartz": "static-1.6771",
  "react-dlb": "static-1.73",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5402",
  "UIComponents": "static-3.8211",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.82",
  "foundations-assets": "static-1.4665",
  "foundations-components": "static-1.7575",
  "foundations-components-test-utils": "static-1.5058",
  "foundations-theming": "static-1.4238",
  "hub-http": "static-1.6048",
  "quartz-config": "static-1.549",
  "quartz-core": "static-1.5990",
  "quick-fetch": "static-1.3765",
  "raven": "static-3.5725",
  "react": "static-7.180",
  "react-rhumb": "static-1.16480",
  "SharedI18nStrings": "static-1.180",
  "ui-addon-i18n": "static-1.10972",
  "usage-tracker": "static-1.7164",
  "usage-tracker-anonymous": "static-1.5581",
  "usage-tracker-core": "static-1.7014",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3957",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3255",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3048",
  "quartz-webpack": "static-1.2995",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.78",
  "HeadJS": "static-2.718",
  "framer-motion": "static-1.68",
  "hs-test-utils-bend-plugin": "static-1.2946",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "ts-schema": "static-1.3932",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "react-utils": "static-2.5202",
  "StyleGuideUI": "static-3.484",
  "jasmine": "static-4.4154",
  "rpc-client-utils": "static-1.4463",
  "HubStyle": "static-2.11572",
  "ui-addon-draggable": "static-3.4595",
  "cssUtils": "static-1.744",
  "hs-story-utils": "static-1.9254",
  "icons": "static-2.624",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.95",
  "ui-images": "static-2.1104",
  "bend-plugin-foundations-components": "static-1.3844",
  "floating-ui": "static-1.52",
  "foundations-theming-specialty": "static-1.1954",
  "react-aria": "static-1.62",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1298",
  "ui-fonts": "static-1.526",
  "foundations-components-legacy": "static-1.600",
  "bend-plugin-foundations-theming": "static-1.2721",
  "foundations-theming-base": "static-1.3223",
  "stylex": "static-1.28",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.803",
  "hubspotter-http": "static-1.4505",
  "mobile-manifest-mixins": "static-1.491",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.446",
  "quartz-head": "static-1.436",
  "quartz-i18n": "static-1.446",
  "quartz-routing": "static-1.201",
  "quartz-test": "static-1.446",
  "quartz-tracking": "static-1.150",
  "usage-tracker-container": "static-1.7154",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.2970",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.66",
  "sassPrefix": "static-1.152",
  "hubspotter-http-shared-msw-handlers": "static-1.9532"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5352",
  "data-fetching-client": "/data-fetching-client/static-1.9505",
  "head-dlb": "/head-dlb/static-1.4841",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7835",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9534",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11264",
  "I18n": "/I18n/static-7.1580",
  "jasmine-runner": "/jasmine-runner/static-1.6299",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4615",
  "quartz": "/quartz/static-1.6771",
  "react-dlb": "/react-dlb/static-1.73",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5402",
  "UIComponents": "/UIComponents/static-3.8211",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
  "foundations-assets": "/foundations-assets/static-1.4665",
  "foundations-components": "/foundations-components/static-1.7575",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5058",
  "foundations-theming": "/foundations-theming/static-1.4238",
  "hub-http": "/hub-http/static-1.6048",
  "quartz-config": "/quartz-config/static-1.549",
  "quartz-core": "/quartz-core/static-1.5990",
  "quick-fetch": "/quick-fetch/static-1.3765",
  "raven": "/raven/static-3.5725",
  "react": "/react/static-7.180",
  "react-rhumb": "/react-rhumb/static-1.16480",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10972",
  "usage-tracker": "/usage-tracker/static-1.7164",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5581",
  "usage-tracker-core": "/usage-tracker-core/static-1.7014",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3255",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3048",
  "quartz-webpack": "/quartz-webpack/static-1.2995",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.78",
  "HeadJS": "/HeadJS/static-2.718",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2946",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "ts-schema": "/ts-schema/static-1.3932",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "react-utils": "/react-utils/static-2.5202",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "jasmine": "/jasmine/static-4.4154",
  "rpc-client-utils": "/rpc-client-utils/static-1.4463",
  "HubStyle": "/HubStyle/static-2.11572",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4595",
  "cssUtils": "/cssUtils/static-1.744",
  "hs-story-utils": "/hs-story-utils/static-1.9254",
  "icons": "/icons/static-2.624",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.95",
  "ui-images": "/ui-images/static-2.1104",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3844",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1954",
  "react-aria": "/react-aria/static-1.62",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1298",
  "ui-fonts": "/ui-fonts/static-1.526",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.600",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2721",
  "foundations-theming-base": "/foundations-theming-base/static-1.3223",
  "stylex": "/stylex/static-1.28",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.803",
  "hubspotter-http": "/hubspotter-http/static-1.4505",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.491",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.446",
  "quartz-head": "/quartz-head/static-1.436",
  "quartz-i18n": "/quartz-i18n/static-1.446",
  "quartz-routing": "/quartz-routing/static-1.201",
  "quartz-test": "/quartz-test/static-1.446",
  "quartz-tracking": "/quartz-tracking/static-1.150",
  "usage-tracker-container": "/usage-tracker-container/static-1.7154",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.2970",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.66",
  "sassPrefix": "/sassPrefix/static-1.152",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9532"
}
};
